const EXPANDED_SECTIONS_STORAGE_KEY = 'frontdoor_report_library_expanded_sections';

// Deprecated - We switched to collapsed by default and tracking expanded section IDs instead
//              Some user's may still have the old key around in localStorage. Keep this in mind if we decide to switch back to collapsed by default.
// const COLLAPSED_SECTIONS_STORAGE_KEY = 'frontdoor_report_library_collapsed_sections';

// TODO(db): Persist expanded section ids with the same
// `user_report_library_pref` payload as reportLibraryOrderStorage.

export function getStoredExpandedSectionIds(): string[] {
    try {
        const expandedSections = localStorage.getItem(EXPANDED_SECTIONS_STORAGE_KEY);
        if (!expandedSections) {
            return [];
        }

        const parsed: unknown = JSON.parse(expandedSections);
        if (!Array.isArray(parsed)) {
            return [];
        }

        return parsed.filter((id): id is string => typeof id === 'string');
    } catch {
        return [];
    }
}

export function setStoredExpandedSectionIds(sectionIds: string[]): void {
    localStorage.setItem(EXPANDED_SECTIONS_STORAGE_KEY, JSON.stringify(sectionIds));
}
